export const identityType = [
  { id: '1', label: 'Identifier' },
  { id: '2', label: 'Data Subject Variable' },
]
